/* ASSETS ACTION TYPES */
export const assetActions = {
  clear: {
    CLEAR_ASSETS_STATUS: 'CLEAR_ASSETS_STATUS',
    CLEAR_FILTERS: 'CLEAR_FILTERS',
    CLEAR_FILTERS_FAILURE: 'CLEAR_FILTERS_FAILURE',
  },
  delete: {
    CLEAR_DELETE: 'CLEAR_DELETE',
    DELETE_ASSET_SUCCESS: 'DELETE_ASSET_SUCCESS',
    DELETE_ASSET_FAILURE: 'DELETE_ASSET_FAILURE',
    DELETING_ASSET: 'DELETING_ASSET',
    STAGE_ASSET_DELETION: 'STAGE_ASSET_DELETION',
    UNSTAGE_ASSET_DELETION: 'UNSTAGE_ASSET_DELETION',
  },
  filter: {
    FILTER_UPDATED: 'FILTER_UPDATED',
    FILTER_UPDATE_FAILURE: 'FILTER_UPDATE_FAILURE',
  },
  lock: {
    TOGGLE_LOCK_ASSET_SUCCESS: 'TOGGLE_LOCK_ASSET_SUCCESS',
    TOGGLING_LOCK_ASSET_FAILURE: 'TOGGLING_LOCK_ASSET_FAILURE',
    TOGGLING_LOCK_ASSET_SUCCESS: 'TOGGLING_LOCK_ASSET_SUCCESS',
  },
  paginate: {
    PAGE_UPDATE: 'PAGE_UPDATE',
    PAGE_UPDATE_FAILURE: 'PAGE_UPDATE_FAILURE',
    RESET_PAGE: 'RESET_PAGE',
  },
  request: {
    REQUEST_ASSETS_SUCCESS: 'REQUEST_ASSETS_SUCCESS',
    REQUEST_ASSETS_FAILURE: 'REQUEST_ASSETS_FAILURE',
    REQUESTING_ASSETS: 'REQUESTING_ASSETS',
    UPDATE_REQUEST: 'UPDATE_REQUEST',
  },
  sort: {
    SORT_UPDATE: 'SORT_UPDATE',
    SORT_UPDATE_FAILURE: 'SORT_UPDATE_FAILURE',
  },
  search: {
    SEARCH_UPDATE: 'SEARCH_UPDATE',
    SEARCH_UPDATE_FAILURE: 'SEARCH_UPDATE_FAILURE',
  },
  select: {
    SELECT_ASSET: 'SELECT_ASSET',
    CLEAR_SELECTED_ASSET: 'CLEAR_SELECTED_ASSET',
  },
  upload: {
    UPLOADING_ASSETS: 'UPLOADING_ASSETS',
    UPLOAD_ASSET_SUCCESS: 'UPLOAD_ASSET_SUCCESS',
    UPLOAD_ASSET_FAILURE: 'UPLOAD_ASSET_FAILURE',
    UPLOAD_EXCEED_MAX_COUNT_ERROR: 'UPLOAD_EXCEED_MAX_COUNT_ERROR',
    UPLOAD_EXCEED_MAX_SIZE_ERROR: 'UPLOAD_EXCEED_MAX_SIZE_ERROR',
    UPLOAD_INVALID_FILE_TYPE_ERROR: 'UPLOAD_INVALID_FILE_TYPE_ERROR',
  },
  imagePreview: {
    IMAGE_PREVIEW_UPDATE: 'IMAGE_PREVIEW_UPDATE',
  },
};

export const accessibilityActions = {
  clear: {
    CLEAR_ACCESSIBILITY_STATUS: 'CLEAR_ACCESSIBILITY_STATUS',
  },
  submit: {
    ACCESSIBILITY_FORM_SUBMIT_SUCCESS: 'ACCESSIBILITY_FORM_SUBMIT_SUCCESS',
    ACCESSIBILITY_FORM_SUBMIT_RATE_LIMIT_FAILURE: 'ACCESSIBILITY_FORM_SUBMIT_RATE_LIMIT_FAILURE',
  },
};

export const courseChecklistActions = {
  request: {
    REQUESTING_COURSE_BEST_PRACTICES: 'REQUESTING_COURSE_BEST_PRACTICES',
    REQUEST_COURSE_BEST_PRACTICES_SUCCESS: 'REQUEST_COURSE_BEST_PRACTICES_SUCCESS',
    REQUEST_COURSE_BEST_PRACTICES_FAILURE: 'REQUEST_COURSE_BEST_PRACTICES_FAILURE',
    REQUESTING_COURSE_LAUNCH: 'REQUESTING_COURSE_LAUNCH',
    REQUEST_COURSE_LAUNCH_SUCCESS: 'REQUEST_COURSE_LAUNCH_SUCCESS',
    REQUEST_COURSE_LAUNCH_FAILURE: 'REQUEST_COURSE_LAUNCH_FAILURE',
  },
};
